import "../../assets/css/Refer.module.css";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";

const Refer = ({ user }) => {
  const copyCode = (e) => {
    navigator.clipboard.writeText(
      `https://kingmastar.in/login/${user?.referral_code}`,
    );
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const shareOnWhatsApp = () => {
    const referralCode = user?.referral_code || "";

    const message = `Play On King Master

लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI या QR code में ट्रांसफर कर सकते हैं।

Auto Deposit & Auto Withdrawal

Instant Withdrawal Via UPI/Bank/QR code

Commission 5% Only
Referral commission 3%

100% भरोसेमंद प्लेटफ़ॉर्म

24x7 Live Chat & Call Support

https://kingmastar.in/login/${referralCode}`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  };

  if (user === undefined) {
    return null;
  }

  return (
    <>
      <div className="leftContainer page_layout">
        <section className="refer-earn-premium ">
          <div className="refer-hero-card">
            <div className="hero-text-side">
              <span className="hero-badge">Special Program</span>
              <h1 className="hero-title">
                Refer & <span className="text-gradient">Earn</span>
              </h1>
              <p className="hero-desc">
                Share the joy with friends and unlock exclusive cash rewards for
                every sign-up!
              </p>
            </div>
            <div className="hero-image-side">
              <img
                src="/images/refer.png"
                alt="Refer and Earn"
                className="floating-img"
              />
            </div>
          </div>

          <div className="referral-share-box">
            <p className="share-label">Referral Code</p>
            <div className="code-capsule">
              <code className="main-code">{user?.referral_code}</code>
              <button className="copy-trigger" onClick={(e) => copyCode(e)}>
                COPY
              </button>
            </div>
          </div>
          <div className="whatsapp_share_btn">
            <a onClick={shareOnWhatsApp}>
              <BsWhatsapp className="icons" />
              <span class="ml-2">Whatsapp</span>
            </a>
          </div>

          <div className="performance-divider">
            <span>Your Performance</span>
          </div>

          <div className="stats-dashboard">
            <div className="dashboard-card users-card">
              <div className="dashboard-content">
                <p className="dashboard-label">Referred Players</p>
                <h2 className="dashboard-value">
                  {user?.referral_user?.length}
                </h2>
              </div>
              <div className="dashboard-icon-bg">
                <img src="/images/rupee.png" alt="rupee" />
              </div>
            </div>

            <div className="dashboard-card earnings-card">
              <div className="dashboard-content">
                <p className="dashboard-label">Referral Earning</p>
                <h2 className="dashboard-value">₹{user?.referral_earning}</h2>
              </div>
              <div className="dashboard-icon-bg">
                <img src="/images/rupee.png" alt="rupee" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Refer;
